const SET_PROMOTION = 'SET_PROMOTION'
const GET_PROMOTION_REQUEST = 'GET_PROMOTION_REQUEST'
const GET_PROMOTION_FAILURE = 'GET_PROMOTION_FAILURE'
const GET_PROMOTION_SUCCESS = 'GET_PROMOTION_SUCCESS'
const REDEEM_PROMOTION_REQUEST = 'REDEEM_PROMOTION_REQUEST'
const REDEEM_PROMOTION_SUCCESS = 'REDEEM_PROMOTION_SUCCESS'
const REDEEM_PROMOTION_ERROR = 'REDEEM_PROMOTION_ERROR'
const GET_PROMOTION_TERMS_REQUEST = 'GET_PROMOTION_TERMS_REQUEST'
const GET_PROMOTION_TERMS_FAILURE = 'GET_PROMOTION_TERMS_FAILURE'
const GET_PROMOTION_TERMS_SUCCESS = 'GET_PROMOTION_TERMS_SUCCESS'
const GET_ALL_PROMOTIONS_REQUEST = 'GET_ALL_PROMOTIONS_REQUEST'
const GET_ALL_PROMOTIONS_SUCCESS = 'GET_ALL_PROMOTIONS_SUCCESS'
const GET_ALL_PROMOTIONS_FAILURE = 'GET_ALL_PROMOTIONS_FAILURE'

export default {
  SET_PROMOTION,
  GET_PROMOTION_REQUEST,
  GET_PROMOTION_FAILURE,
  GET_PROMOTION_SUCCESS,
  REDEEM_PROMOTION_REQUEST,
  REDEEM_PROMOTION_SUCCESS,
  REDEEM_PROMOTION_ERROR,
  GET_PROMOTION_TERMS_REQUEST,
  GET_PROMOTION_TERMS_FAILURE,
  GET_PROMOTION_TERMS_SUCCESS,
  GET_ALL_PROMOTIONS_FAILURE,
  GET_ALL_PROMOTIONS_REQUEST,
  GET_ALL_PROMOTIONS_SUCCESS,
}
